import { render, staticRenderFns } from "./SwitchPlans.vue?vue&type=template&id=5923fe45"
import script from "./SwitchPlans.vue?vue&type=script&lang=js"
export * from "./SwitchPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports